import { render, staticRenderFns } from "./Wysiwyg.vue?vue&type=template&id=53adabe4&scoped=true&"
import script from "./Wysiwyg.vue?vue&type=script&lang=ts&"
export * from "./Wysiwyg.vue?vue&type=script&lang=ts&"
import style0 from "./Wysiwyg.vue?vue&type=style&index=0&id=53adabe4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53adabe4",
  null
  
)

export default component.exports